export interface UnitPriceEmployeeArray {
  unitPriceId: number;
  employeeId: number;
  employeeName: string;
  employeeCode: string;
  unitPrice: UnitPrices;
}

export interface UnitPrices {
  january: number | null;
  february: number | null;
  march: number | null;
  april: number | null;
  may: number | null;
  june: number | null;
  july: number | null;
  august: number | null;
  september: number | null;
  october: number | null;
  november: number | null;
  december: number | null;
  average: number | null;
}

export interface UnitPriceGetResponse {
  yearId: number;
  employees: UnitPriceEmployeeArray[];
}

export const EmptyUnitPriceEmployeeArray: UnitPriceEmployeeArray = {
  unitPriceId: 0,
  employeeId: 0,
  employeeName: '',
  employeeCode: '',
  unitPrice: {
    january: null,
    february: null,
    march: null,
    april: null,
    may: null,
    june: null,
    july: null,
    august: null,
    september: null,
    october: null,
    november: null,
    december: null,
    average: null,
  },
};
export const EmptyUnitPriceGetResponse: UnitPriceGetResponse = {
  yearId: 0,
  employees: [EmptyUnitPriceEmployeeArray],
};
